import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';
import { changeBedroomsCount } from '../../../filters/state/advanced/bedrooms_min_count';
import { changeDealType } from '../../../filters/state/deal_type';
import { selectOfferType } from '../../../filters/state/offer_type';
import { changeRoom } from '../../../filters/state/room';
import { EBedroomsCount, ERoomType, ESortValue, ESuburbanOfferFilter } from '../../../json_query';
import { FDealType, FOfferType } from '../../../utils/category';
import { DealOfferRooms } from './index';
import { changeSort } from '../../state/sort';
import { clearRailwayTags } from '../../state/geo';
import { setSuburbanOfferFilter, unsetSuburbanOfferFilter } from '../../state/suburban_offer_filter';
import { changeAutoOfferTooltipVisibility } from '../../state/kp_id';
import { ECoworkingOfferType } from '../../../repositories/common/json_query/enums';
import { selectCoworkingOfferType } from '../../state/coworking_offer_type';
import { closedCoworkingHelper } from '../../../serp/state/coworking_experiments/coworkingHelper';

export function mapStateToProps(state: IAppState) {
  const {
    filters: { jsonQuery },
    experiments,
    isAutoOfferChangeTooltipVisible,
    results,
  } = state;

  return {
    resultJsonQuery: results.jsonQuery,
    jsonQuery,
    experiments,
    isAutoOfferChangeTooltipVisible: Boolean(isAutoOfferChangeTooltipVisible),
    isCoworkingEnabled: state.config.get('Coworking.Enabled'),
    isCoworkingHelperVisible: state.coworkingExperiments.coworkingHelper.isOpen,
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    closeAutoOfferChangeTooltip: () => {
      dispatch(changeAutoOfferTooltipVisibility(false));
    },
    onBedroomsChanged: (value: EBedroomsCount) => {
      dispatch(changeBedroomsCount(value));
    },
    onDealTypeChanged: (dealType: FDealType) => {
      dispatch(changeDealType(dealType));
    },
    onRoomChanged: (rooms: ERoomType[]) => {
      dispatch(changeRoom(rooms));
    },
    onOfferTypeSelected: (type: FOfferType) => {
      dispatch(selectOfferType(type));
    },
    onCoworkingOfferTypeSelected: (type: ECoworkingOfferType) => {
      dispatch(selectCoworkingOfferType(type));
    },
    onSuburbanOfferFilterChanged: (value: ESuburbanOfferFilter) => {
      if (value === ESuburbanOfferFilter.Any) {
        dispatch(unsetSuburbanOfferFilter());
      } else {
        dispatch(setSuburbanOfferFilter(value));
      }
    },
    setDefaultSort: () => {
      /**
       * Хардкодим тут параметры, так как после каждой смены
       * типа объекта меняем тип сортировки на default
       */
      dispatch(changeSort(ESortValue.Default, true));
    },
    clearRailwayTags: () => {
      dispatch(clearRailwayTags());
    },
    onClickCoworkingHelperOutside: () => {
      dispatch(closedCoworkingHelper());
    },
  };
}

export const DealOfferRoomsContainer = connect(mapStateToProps, mapDispatchToProps)(DealOfferRooms);
